import { IconButton, InputAdornment, TextField, TextFieldProps, useTheme } from '@material-ui/core';
import { Close, Search } from '@material-ui/icons';
import React from 'react';

export type SearchBarProps = TextFieldProps & {
  searchString?: string | null;
  onSearchChange?: (value: string) => void;
  placeholder?: string;
  fullWidth?: boolean;
  style?: React.CSSProperties;
};

export const SearchBar = (props: SearchBarProps): JSX.Element => {
  const theme = useTheme();

  const {
    searchString: filterValue,
    onSearchChange,
    placeholder = 'Search',
    fullWidth,
    style,
    ...textFieldProps
  } = props;

  const handleChange = (value: string) => {
    onSearchChange?.(value);
  };

  return (
    <TextField
      size="small"
      style={{ ...style }}
      fullWidth={fullWidth}
      placeholder={placeholder}
      data-testid={placeholder.replace(/\s+/g, '-').toLowerCase() + '-search-bar'}
      value={filterValue}
      onChange={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => handleChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" style={{ color: theme.palette.text.secondary }}>
            <Search />
          </InputAdornment>
        ),
        endAdornment: filterValue && (
          <InputAdornment position="end" style={{ position: 'absolute', right: 0 }}>
            <IconButton
              size="small"
              data-testid="clear-button"
              onClick={() => {
                handleChange('');
              }}
            >
              <Close fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...textFieldProps}
    />
  );
};
